export function getKetchScript(ketchId: string): string {
  return `!function(){window.semaphore=window.semaphore||[];window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="${ketchId}",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e);}();`;
}

export function getKetchScreen(screens: any[]) {
  return screens.find((screen) => screen.type === 'applicaster-cmp-ketch');
}
